import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styled from 'styled-components'
import {
	CPFInput,
	EmailInput,
	TextInput,
	RGInput
} from '../../../../../components/form-components/inputs.component'
import Yup from './../../../../../helpers/custom-yup'

const schema = Yup.object().shape({
	rg: Yup.string()
		.rg()
		.required('Informe o RG')
})

const StyledInputContainer = styled.div`
	margin-top: 4rem;
`

const StyledInputWithInformationContainer = styled.div`
	margin-top: 4rem;
	input {
		width: 300px;
		@media (max-width: 600px) {
			width: 100%;
		}
	}
	.static-information {
		position: absolute;
		left: 320px;
		bottom: 0;
		margin: 0;
		padding: 0;
	}
	@media (max-width: 600px) {
		.static-information {
			display: none;
		}
	}
	@media (max-width: 320px) {
		input {
			width: 100%;
		}
	}
`

export default class PersonalForm extends Component {
	constructor(props) {
		super(props)
		this.rgRef = React.createRef()
	}

	submit() {
		this.refs.form.submitForm()
	}

	render() {
		const { onSubmit } = this.props
		return (
			<Formik
				initialValues={this.props.initialValues}
				onSubmit={onSubmit}
				validationSchema={schema}
				ref={'form'}
				render={props => (
					<Form noValidate>
						<TextInput
							disabled
							id="name"
							label="Nome"
							maxLength={128}
							autoFocus={true}
							{...props}
						/>
						<StyledInputWithInformationContainer>
							<CPFInput disabled id="cpf" label="CPF" {...props} />
						</StyledInputWithInformationContainer>
						<StyledInputWithInformationContainer>
							<RGInput
								maxLength={14}
								elementRef={this.rgRef}
								id="rg"
								label="RG *"
								information={() => (
									<p className="static-information">
										Para acumular pontos informe esse RG no momento da
										compra no site da Planalto.
									</p>
								)}
								{...props}
							/>
						</StyledInputWithInformationContainer>
						<StyledInputContainer>
							<EmailInput
								disabled
								id="email"
								label="E-mail"
								{...props}
							/>
						</StyledInputContainer>
					</Form>
				)}
			/>
		)
	}
}

PersonalForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onClick: PropTypes.func
}
